import mapboxgl from "mapbox-gl"; // This is a dependency of react-map-gl even if you didn't explicitly install it

import React, { useState, useEffect } from "react";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import { useSelector } from "react-redux";
import { Icon } from "@mui/material";

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

function SiteTrackerMap(props) {
  const defaultViewPort = {
    latitude: 28.836927000000003,
    longitude: 78.79018300000001,
    zoom: 12,
  };
  const [viewPort, setViewport] = useState();
  const changeMap = useSelector((state) => state.mapViews) || "";
  const [selectedMarker, setSelectedMarker] = useState(null);

  function calculateCentroid(coords) {
    // console.log("coords", coords);
    const numCoords = coords.length;

    // Calculate the sum of latitudes and longitudes
    let sumLat = 0;
    let sumLong = 0;

    coords.forEach((coord) => {
      sumLat += coord.Latitude;
      sumLong += coord.Longitude;
    });

    // Calculate the average latitudes and longitudes
    const avgLat = sumLat / numCoords;
    const avgLong = sumLong / numCoords;

    return { latitude: avgLat, longitude: avgLong };
  }

  const setDefaultViewPort = (filteredData) => {
    const currCentroid = calculateCentroid(filteredData);
    console.log("currCentroid", currCentroid);
    if (currCentroid.longitude && currCentroid.latitude) {
      setViewport({
        ...viewPort,
        longitude: currCentroid.longitude,
        latitude: currCentroid.latitude,
        zoom: defaultViewPort.zoom,
      });
    } else {
      console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^")
      setViewport(viewPort);
    }
  };

  useEffect(() => {
    console.log("selectedWorkers ", props.selectedWorkers);
    const filteredMarkers = props.mapMarkers.filter((marker) => {
      const assigned = marker["Assigned Employee"];
      if (!assigned || assigned === "NA") return false;
    
      // Split the string to get the worker ID
      const parts = assigned.split("--");
      if (parts.length < 2) return false;
    
      const workerId = parts[1].trim();
      return props.selectedWorkers[workerId]; // check if workerId is selected
    });
    if (filteredMarkers.length > 0) {
      setDefaultViewPort(filteredMarkers);
    } else if(props.mapMarkers.length > 0){
      setDefaultViewPort(props.mapMarkers);
    } else{
      setViewport(defaultViewPort)
    }
    console.log("filteredMarkers ", filteredMarkers);
    console.log("********** 1st render *********")
  }, [props.selectedWorkers, props.mapMarkers]);

  return (
    <ReactMapGL
      {...viewPort}
      onMove={(evt) => setViewport(evt.viewState)}
      className="map-container"
      style={{ height: "100vh" }}
      projection={"globe"}
      reuseMaps
      attributionControl={false}
      mapStyle={changeMap.value}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      onClick={() => setSelectedMarker(null)}
    >
      {props.mapMarkers &&
        props.mapMarkers.length > 0 &&
        props.mapMarkers
          .filter((marker) => {
            const assigned = marker["Assigned Employee"];
            if (!assigned || assigned === "NA") return false;

            const parts = assigned.split("--");
            if (parts.length < 2) return false;
            if (marker.status === "new") return false;

            const workerId = parts[1].trim();
            return props.selectedWorkers[workerId] === true;
          })
          .map((mapMarker) => {
            const assigned = mapMarker["Assigned Employee"];
            const workerId = assigned?.split("--")[1]?.trim(); // Re-parse here
            return (
              // <Marker
              //   key={mapMarker.ID}
              //   longitude={mapMarker.Longitude}
              //   latitude={mapMarker.Latitude}
              // >
              //   <div
              //     style={{
              //       display: "flex",
              //       alignItems: "center",
              //       gap: "0.2rem", // space between icon and tick
              //     }}
              //   >
              //     <Icon
              //       title={mapMarker.status}
              //       baseClassName="fas"
              //       className={
              //         mapMarker.status === "not-applicable"
              //           ? "fa-circle-minus"
              //           : "fa-location-dot"
              //       }
              //       fontSize="medium"
              //       style={{
              //         color: props.workerColors[workerId] || "white",
              //         fontSize: "0.75rem",
              //       }}
              //     />

              //     {mapMarker.status !== "New-Assigned" && (
              //       <Icon
              //         className="fas fa-check"
              //         style={{
              //           color: "#a8ff00",
              //           fontSize: "0.8rem",
              //         }}
              //         title="Verified"
              //       />
              //     )}
              //   </div>
              // </Marker>
              // <Marker
              //   key={mapMarker.ID}
              //   longitude={mapMarker.Longitude}
              //   latitude={mapMarker.Latitude}
              // >
              //   <div
              //     style={{
              //       display: "flex",
              //       alignItems: "center",
              //       gap: "0.2rem",
              //     }}
              //   >
              //     {mapMarker.status !== "New-Assigned" ? (
              //       <Icon
              //         className="fas fa-check-circle green-icon"
              //         title="Completed"
              //         style={{ fontSize: "0.75rem", color: "#a8ff00" }}
              //       />
              //     ) : (
              //       <Icon
              //         title={mapMarker.status}
              //         baseClassName="fas"
              //         className="fa-location-dot"
              //         fontSize="medium"
              //         style={{
              //           color: props.workerColors[workerId] || "white",
              //           fontSize: "0.75rem",
              //         }}
              //       />
              //     )}
              //   </div>
              // </Marker>
              <Marker
                key={mapMarker.ID}
                longitude={mapMarker.Longitude}
                latitude={mapMarker.Latitude}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.2rem",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // ✅ Prevent map click from firing
                    setSelectedMarker(mapMarker);
                  }}
                >
                  {mapMarker.status !== "New-Assigned" ? (
                    <Icon
                      className="fas fa-check-circle green-icon"
                      title="Completed"
                      style={{ fontSize: "0.75rem", color: props.workerColors[workerId] || "white" }}
                    />
                  ) : (
                    <Icon
                      title={mapMarker.status}
                      baseClassName="fas"
                      className="fa-location-dot"
                      fontSize="medium"
                      style={{
                        color: props.workerColors[workerId] || "white",
                        fontSize: "0.75rem",
                      }}
                    />
                  )}
                </div>
              </Marker>
            );
          })}

      {selectedMarker && (
        <Popup
          longitude={selectedMarker.Longitude}
          latitude={selectedMarker.Latitude}
          closeOnClick={false}
          onClose={() => setSelectedMarker(null)}
          anchor="top"
        >
          <div style={{ fontSize: "0.75rem" }}>
            <strong>ID:</strong> {selectedMarker.ID} <br />
            <strong>Zone:</strong> {selectedMarker.Zone} <br />
            <strong>Size:</strong> {selectedMarker.size}
          </div>
        </Popup>
      )}
    </ReactMapGL>
  );
}

export default SiteTrackerMap;
